module.exports = __webpack_public_path__ + "static/img/16b.f557d04.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/16b.png
// module id = WYdt
// module chunks = 1